import { formatISO } from "date-fns";
import { getGlobalHeadersAsObject } from "../global-headers";

export type KPI = {
	[key: string]: number;
};

export const getKPIs = (from: Date, to: Date): Promise<KPI> => {
	const requestUrl = "/api/v2/statistics/kpis";
	const queryParams = [];

	queryParams.push(["from", encodeURIComponent(formatISO(from))]);
	queryParams.push(["to", encodeURIComponent(formatISO(to))]);

	const queryStr = queryParams.map((qp) => qp.join("=")).join("&");

	return fetch(`${requestUrl}?${queryStr}`, {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	})
		.then((res) => res.json())
		.catch((err) => console.log(err));
};
